/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useState } from 'react';

import { jsx } from '@atlaskit/css';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';

import { ContentComponentContextProvider } from '../../hooks/useContentComponentContext';
import type { ContentComponentProps } from '../../hooks/useContentComponentContext';
import { GlobalWrapper } from '../GlobalWrapper/GlobalWrapperLegacy';

import { ContentComponent } from './ContentComponentLegacy';

export const ContentComponentWrapper = (
	props: Omit<
		ContentComponentProps,
		'isRovoLoading' | 'setIsRovoLoading' | 'cancelRovoPrompt' | 'setCancelRovoPrompt'
	>,
): JSX.Element => {
	const aiDecorationExperiencePluginState = useSharedPluginStateWithSelector(
		props.api,
		['aiExperience'],
		(states) => states.aiExperienceState?.aiDecorationExperiencePluginState,
	);
	const modalMountedTimeStamp = aiDecorationExperiencePluginState?.modalMountedTimeStamp;

	/**
	 * This is to detect the state of the Rovo prompt and loading screens
	 * from RovoInlineChatPrompt used in RovoPromptScreenWithLogic,
	 * as it does not respect the state value from XState.
	 */
	const [isRovoLoading, setIsRovoLoading] = useState(false);

	/* reset the component when start AI again, so that the error boundary will also be reset */
	return (
		<GlobalWrapper>
			{/* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */}
			<ContentComponentContextProvider value={{ ...props, isRovoLoading, setIsRovoLoading }}>
				<ContentComponent key={modalMountedTimeStamp} />
			</ContentComponentContextProvider>
		</GlobalWrapper>
	);
};
